<template>
  <div class="page">
    <div class="m-bg-cover"></div>
    <div class="m-info-box">
      <div class="m-info-tit"><img src="@/assets/img/home/bcInfo.png" alt=""><span>个人信息</span></div>
      <div class="m-nav"><span>姓名</span><p>{{userInfoVO.username}}</p></div>
      <div class="m-nav"><span>证件号码</span><p>{{userInfoVO.idCardNumb}}</p></div>
      <div v-if="userInfoVO.admissionNumb" class="m-nav"><span>准考证号</span><p>{{userInfoVO.admissionNumb}}</p></div>
      <div class="m-nav"><span>考试</span><p>{{userInfoVO.examName}}</p></div>
    </div>
    <div class="m-info-box">
      <div class="m-bast">
        <div><img src="@/assets/img/home/myInfo.png" alt=""><span>考试成绩</span></div>
      </div>
      <div class="m-tab-box">
        <p class="m-tab">考试科目</p>
        <p v-show="publicWay.includes('0')" class="m-tab">考试分数</p>
        <p v-show="publicWay.includes('1')" class="m-tab">考试结果</p>
        <p v-show="publicWay.includes('2')" class="m-tab">编号</p>
      </div>
      <!--userInfoVO.subScoreVOList-->
      <div class="m-nav-box" v-for="(item,index) in userInfoVO.subScoreVOList" :key="index">
        <p class="m-tab">{{item.subName}}</p>
        <p v-show="publicWay.includes('0')"  class="m-tab">{{item.score===null ? '暂无分数' : item.score===-1 ? '缺考' : item.score}}</p>
        <div v-show="publicWay.includes('1')"  class="m-tab">
          <p style="color: #1D232D" v-if="item.scoreStatus===null">暂无结果</p>
          <p v-else-if="item.scoreStatus=='合格'">{{item.scoreStatus}}</p>
          <p style="color: red" v-else-if="item.scoreStatus=='不合格'">{{item.scoreStatus}}</p>
          <p style="color: #1D232D" v-else="">{{item.scoreStatus}}</p>
        </div>
        <p v-show="publicWay.includes('2')"  style="word-break: break-all;" class="m-tab">{{item.certNo||'暂无'}}</p>
      </div>
    </div>
    <div v-if="this.register.publicNoticeId&&isHas" class="m-center">
      <van-button block class="x-btn-log m-btn-width" @click="goDown()">下载证书</van-button>
    </div>
    <!--弹出退出确认框-->
    <van-popup v-model="show" round get-container="body">
      <div class="m-popup">
        <div class="m-title">是否下载证书</div>
        <div class="m-chose">
          <p @click="show=false">取消</p>
          <p @click="getDown()">
            确定
          </p>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
//  import isBetween from "dayjs/plugin/isBetween";
  export default {
    components: {},
    data () {
      return {
        userInfoVO: {},
        register:{},
        publicWay:[],
        show:false,
        token:window.localStorage.getItem('token'),
        isHas:false
      }
    },
    created () {
      if(this.$route.query.id){
        this.getScore()
      }
      if(this.$route.query.examName){
        this.getHistoryScore()
      }
    },
    methods: {
      getScore(){
        if(!this.$route.query.id){
          this.utils.toastNone('缺少参数！')
          return
        }
        this.http.postRequest({
          url:`app/exam/showUserScoreList/${this.$route.query.id}`,
          msg:{},
          success:(res)=>{
            this.userInfoVO = res.data
            this.setParms()
          }
        })
      },
      setParms(){
        this.http.getRequest({
          url:`app/exam/findRegisterInfo/${this.$route.query.id}`,
          msg:{},
          success:(res)=>{
            this.register = res.data&&res.data.register ? res.data.register : {}
            if(this.register.hasDownloadCert==1){
              let subScoreVOList = this.userInfoVO.subScoreVOList&&this.userInfoVO.subScoreVOList.length ? this.userInfoVO.subScoreVOList : []
              let isHas = subScoreVOList.find((item)=>{
                if(item.scoreStatus==='合格'){
                  return item
                }
              })
              if(isHas){
                this.isHas = true
              }else {
                this.isHas = false
              }
            }else {
              this.isHas = true
            }
            if(this.register&&this.register.publicWay){
              this.publicWay = this.register.publicWay.split(',')
            }
          }
        })
      },
      goDown(){
        this.show = true
      },
      getDown(){
        if(this.$route.query.id){
          window.open(`/api/app/exam/downLoadUserScore/${this.$route.query.id}?token=${this.token}`)
        }
        if(this.$route.query.examName){
          window.open(`/api/app/user/downLoadHistoryExamGrade/${this.$route.query.examName}?token=${this.token}`)
        }
        this.show = false
      },
      getHistoryScore(){
        this.http.postRequest({
          url:`app/user/findHistoryExamGradeInfo`,
          msg:{examName:decodeURI(this.$route.query.examName)},
          success:(res)=>{
            if(res.data.userInfo){
              let userInfo = res.data.userInfo
              this.$set(this.userInfoVO,'username',userInfo.userName)
              this.$set(this.userInfoVO,'idCardNumb',userInfo.idCardNum)
              this.$set(this.userInfoVO,'admissionNumb',userInfo.examTicketNo)
              this.$set(this.userInfoVO,'examName',userInfo.examName)
              if(res.data&&res.data.examGradeList&&res.data.examGradeList.length){
                let subScoreVOList = res.data.examGradeList.map((item)=>{
                  let obj = {}
                  obj.subName = item.subjectName
                  obj.score = item.score
                  obj.scoreStatus = item.scoreStatus
                  obj.certNo = item.certNo
                  return obj
                })
                this.$set(this.userInfoVO,'subScoreVOList',subScoreVOList)
              }
              if(res.data&&res.data.userInfo&&res.data.userInfo.publicWay){
                let arrObj = res.data.userInfo.publicWay.split(',')
                this.publicWay = arrObj
              }
              if(res.data&&res.data.userInfo&&res.data.userInfo.publicNoticeId){
                this.$set(this.register,'publicNoticeId',res.data.userInfo.publicNoticeId)
              }
            }
          }
        })
      }
    },
    mounted () {
//      this.dayjs.extend(isBetween)
//      const now = this.dayjs();
//      const start = this.dayjs('2022-01-01 09:00:00');
//      const end = this.dayjs('2022-01-02 18:00:00');
//      const isBetweens = now.isBetween(start, end);
//      console.log('ssss',isBetweens); // true or false
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style ref="stylesheet/less" lang="less" scoped>
  @import "~@/assets/css/variable.less";
.page{
  background: #F4F6F9;
  padding: 0 12px 90px 12px;
  .m-bg-cover{
    position: absolute;
    left: 0;
    right: 0;
    height: 180px;
    background: linear-gradient(360deg, #F4F6F9 0%, #2B6CF9 28% ,#2B6CF9 100%);
    z-index: -1;
  }
  .m-info-box{
    background: #ffffff;
    border-radius: 4px;
    padding: 15px 12px 12px 12px;
    margin-top: 18px;
    .m-info-tit{
      display: flex;
      align-items: center;
      padding-bottom: 15px;
      >img{
        width: 16px;
        height: 16px;
      }
      >span{
        color: #2B6CF9;
        font-weight: bold;
        margin-left: 3px;
      }
    }
    .m-bast{
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-bottom: 15px;
      >div{
        display: flex;
        align-items: center;
        >img{
          width: 16px;
          height: 16px;
        }
        >span{
          color: #2B6CF9;
          font-weight: bold;
          margin-left: 3px;
        }
      }
      .m-btn{
        height: 27px;
        line-height: 27px;
        color: #2B6CF9;
        border:1Px solid #2B6CF9;
      }
    }
    .m-nav{
      padding-bottom: 20px;
      display: flex;
      >span{
        display: inline-block;
        width: 90px;
        color: #8D8F93;
      }
      >p{
        flex: 1;
        text-align: right;
      }
      .m-pic{
        flex: 1;
        text-align: right;
        >img{
          width: 80px;
          height: 80px;
          object-fit: contain;
        }
      }
    }
  }
  .m-tab-box{
    padding: 0 10px;
    height: 35px;
    display: flex;
    align-items: center;
    gap:10px;
    background: #F9F9F9;
    border-radius: 4px 4px 4px 4px;
    .m-tab{
      color: #8D8F93;
    }
    .m-tab:nth-child(1){
      width: 100%;
      text-align: center;
    }
    .m-tab:nth-child(2){
      width: 100%;
      text-align: center;
    }
    .m-tab:nth-child(3){
      width: 100%;
      text-align: center;
    }
    .m-tab:nth-child(4){
      width: 100%;
      text-align: center;
    }
  }
  .m-nav-box{
    padding: 15px 10px 0 15px;
    display: flex;
    align-items: center;
    gap:10px;
    .m-tab{
      color: #1D232D;
    }
    .m-tab:nth-child(1){
      width: 100%;
      text-align: center;
    }
    .m-tab:nth-child(2){
      width: 100%;
      text-align: center;
    }
    .m-tab:nth-child(3){
      width: 100%;
      text-align: center;
      color: #2B6CF9;
    }
    .m-tab:nth-child(4){
      width: 100%;
      text-align: center;
    }
  }
  .m-center{
    padding-bottom: 30px;
    .m-btn-width{
      width: 144px;
      margin: 58px auto 0 auto;
    }
  }
}
  .m-popup {
    width: 300px;
    height: 103px;
    background: #ffffff;
    font-size: 15px;
    overflow: hidden;
    .m-title {
      text-align: center;
      font-size: 15px;
      font-weight: bold;
      height: 53px;
      line-height: 53px;
      border-bottom: 1Px solid #E7E7E7;
    }
    .m-chose {
      display: flex;
      > p {
        flex: 1;
        text-align: center;
        height: 50px;
        line-height: 50px;
        font-size: 15px;
        font-weight: bold;
      }
      > p:nth-child(2) {
        color: #2B6CF9;
        border-left: 1Px solid #E7E7E7;
      }
      a{
        display: block;
        width: 100%;
        height: 100%;
      }
    }
  }

  .van-popup--center.van-popup--round {
    border-radius: 4px !important;
  }
</style>

